/* eslint-disable no-param-reassign */
import Vue from 'vue';

import { pesquisar } from '@/resources/licitacoesPesquisa';
import { defaultLicitacoesFilters } from '@/utils/licitacoesFiltersQuery';

const moduleState = {
  items: [],
  count: 0,
  loading: false,
  filters: defaultLicitacoesFilters(),
};

const mutations = {
  setFilters(currentState, filters) {
    currentState.filters = { ...defaultLicitacoesFilters(), ...filters };
  },
  setItems(currentState, items) {
    currentState.items = (items || []).map(item => ({
      ...item,
      itens: Array.isArray(item.itens) ? item.itens : [],
    }));
  },
  setLoading(currentState, loading) {
    currentState.loading = loading;
  },
  setPage(currentState, pagina) {
    currentState.filters = { ...currentState.filters, pagina: Number(pagina) || 1 };
  },
  setPerPage(currentState, porPagina) {
    currentState.filters = {
      ...currentState.filters,
      pagina: 1,
      porPagina: Number(porPagina) || 20,
    };
  },
  setCount(currentState, count) {
    currentState.count = Number(count) || 0;
  },
  // Atualiza in-place para não trocar a referência da linha do b-table (senão o detail fecha).
  setRowItens(currentState, { licitacaoId, origem, itens }) {
    const index = currentState.items.findIndex(
      item => item.id === licitacaoId && item.origem === origem,
    );
    if (index < 0 || !Array.isArray(itens)) return;
    Vue.set(currentState.items[index], 'itens', itens);
  },
  setUltimaPropostaItens(currentState, { licitacaoId, itens }) {
    const index = currentState.items.findIndex(
      item => item.id === licitacaoId && item.origem === 'OC',
    );
    if (index < 0 || !Array.isArray(itens)) return;

    const row = currentState.items[index];
    if (!Array.isArray(row.itens)) {
      Vue.set(row, 'itens', []);
    }
    const { itens: rowItens } = row;
    itens.forEach(propostaItem => {
      const itemIndex = rowItens.findIndex(item => item.id === propostaItem.id);
      if (itemIndex < 0) return;
      const currentItem = rowItens[itemIndex];
      currentItem.ultimaProposta = propostaItem.createdAt || propostaItem.ultimaProposta || null;
      Vue.set(rowItens, itemIndex, currentItem);
    });
  },
};

const actions = {
  async pesquisarLicitacoes({ commit, state: currentState }, { company = {} } = {}) {
    commit('setLoading', true);
    try {
      const { data } = await pesquisar(currentState.filters, {
        cadastradas: Boolean(company.buyer),
      });
      commit('setItems', data.data || []);
      commit('setCount', data.count);
      return data;
    } finally {
      commit('setLoading', false);
    }
  },
  limparFiltros({ commit }) {
    commit('setFilters', defaultLicitacoesFilters());
  },
};

export default {
  namespaced: true,
  state: moduleState,
  mutations,
  actions,
};
